import { useEffect, useState } from "react";

export const useDropdownState = (type, activeType, setActiveType) => {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const handleButton = () => {
    if (activeType !== type) {
      setActiveType(type);
    }
    setIsDropDownOpen(current => !current);
  };

  const isOpenMenu = () => {
    setActiveType(type);
    setIsDropDownOpen(true);
    setIsHovering(true);
  };

  const isCloseMenu = () => {
    setIsHovering(false);
    setIsDropDownOpen(false);
  };

  const handleCloseMenu = () => {
    if (!isHovering) {
      setIsDropDownOpen(false);
    }
  };

  useEffect(() => {
    if (activeType !== type) {
      setIsDropDownOpen(false);
    }
  }, [activeType, type]);

  return {
    isDropDownOpen,
    handleButton,
    isOpenMenu,
    isCloseMenu,
    handleCloseMenu,
    setIsHovering,
  };
};
